module.exports = __webpack_public_path__ + "img/stepsOver.a6f27662.svg";